module.exports = __webpack_public_path__ + "img/leads.248a304b.png";